import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/media/${resource.id}/edit`} />,
    <MenuItem key='View'>
      <a
        style={{ color: 'inherit', textDecoration: 'none' }}
        href={resource.url}
        target='_blank' rel="noreferrer"
      >
        View
      </a>
    </MenuItem>
  ]
}

export default buildMenuItems
